import { ShootingEventConfig } from "../../types/ShootingEventConfig";

const SELECTED_SHOOTING_EVENT_ID_LOCAL_STORAGE_KEY = "selectedShootingEventId";

export const getRememberedShootingEventId = (shootingEventConfigs: ShootingEventConfig[]): string => {
  const storedShootingEventId = localStorage.getItem(SELECTED_SHOOTING_EVENT_ID_LOCAL_STORAGE_KEY);
  if (storedShootingEventId && shootingEventConfigs.some((config) => config.shootingEventId === storedShootingEventId)) {
    return storedShootingEventId;
  }

  return shootingEventConfigs[0]?.shootingEventId ?? "";
};

export const getInitialShootingEventId = (
  shootingEventConfigs: ShootingEventConfig[],
  preferredShootingEventId?: string
): string => {
  return preferredShootingEventId || getRememberedShootingEventId(shootingEventConfigs);
};

export const rememberShootingEventId = (shootingEventId: string): void => {
  localStorage.setItem(SELECTED_SHOOTING_EVENT_ID_LOCAL_STORAGE_KEY, shootingEventId);
};
